(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unsync-comparison')) {
  customElements.define('unsync-comparison', class extends HTMLElement {
    static seen = new Set();
    connectedCallback() {
      this.cursor = this.querySelector('.before-after__cursor');
      if (!this.cursor) return;
      this.frame = 0;
      this.key = this.dataset.introKey;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.base = parseFloat(getComputedStyle(this).getPropertyValue('--before-after-initial-drag-position')) || 50;
      this.position = this.base;
      this.cursor.setAttribute('role', 'slider');
      this.cursor.setAttribute('tabindex', '0');
      this.cursor.setAttribute('aria-label', 'Image comparison');
      this.cursor.setAttribute('aria-valuemin', '0');
      this.cursor.setAttribute('aria-valuemax', '100');
      this.paint = value => {
        this.position = Math.max(0, Math.min(100, value));
        this.style.setProperty('--before-after-initial-drag-position', this.position + '%');
        this.style.setProperty('--clip-path-offset', '0px');
        this.cursor.setAttribute('aria-valuenow', String(Math.round(this.position)));
      };
      this.paint(this.base);
      this.stop = () => {
        cancelAnimationFrame(this.frame); this.frame = 0;
        this.constructor.seen.add(this.key);
        if (this.observer) this.observer.disconnect();
      };
      this.down = event => {
        if (event.button !== 0 || event.isPrimary === false) return;
        this.stop(); this.pointer = event.pointerId;
        this.startX = event.clientX; this.startPosition = this.position;
        this.cursor.setPointerCapture(event.pointerId);
        event.preventDefault();
      };
      this.move = event => {
        if (this.pointer !== event.pointerId) return;
        this.paint(this.startPosition + (event.clientX - this.startX) / this.getBoundingClientRect().width * 100);
      };
      this.up = () => { this.pointer = null; };
      this.keydown = event => {
        const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault(); this.stop();
        this.paint(event.key === 'Home' ? 0 : event.key === 'End' ? 100 : this.position + (event.key === 'ArrowLeft' ? -2 : 2));
      };
      this.preference = () => { if (this.reduced.matches) { this.stop(); if (this.pointer == null) this.paint(this.base); } };
      this.cursor.addEventListener('pointerdown', this.down);
      this.cursor.addEventListener('pointermove', this.move);
      this.cursor.addEventListener('pointerup', this.up);
      this.cursor.addEventListener('pointercancel', this.up);
      this.cursor.addEventListener('lostpointercapture', this.up);
      this.cursor.addEventListener('keydown', this.keydown);
      this.reduced.addEventListener('change', this.preference);
      if (this.reduced.matches || this.constructor.seen.has(this.key)) return;
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        if (!entry.isIntersecting) {
          if (this.frame) { this.stop(); this.paint(this.base); }
          return;
        }
        if (entry.intersectionRatio < .35 || this.constructor.seen.has(this.key)) return;
        this.constructor.seen.add(this.key);
        const points = [this.base, Math.max(0, this.base - 6), Math.min(100, this.base + 6), this.base];
        let start;
        const animate = time => {
          if (start === undefined) start = time;
          const elapsed = time - start;
          const phase = Math.max(0, Math.min(3, (elapsed - 250) / 550));
          if (phase >= 3) { this.paint(this.base); this.frame = 0; this.observer.disconnect(); return; }
          const index = Math.floor(phase), t = phase - index;
          const ease = .5 - Math.cos(t * Math.PI) / 2;
          this.paint(points[index] + (points[index + 1] - points[index]) * ease);
          this.frame = requestAnimationFrame(animate);
        };
        this.frame = requestAnimationFrame(animate);
      }, { threshold: [0, .35] });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (!this.cursor) return;
      cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
      this.cursor.removeEventListener('pointerdown', this.down);
      this.cursor.removeEventListener('pointermove', this.move);
      for (const event of ['pointerup', 'pointercancel', 'lostpointercapture']) this.cursor.removeEventListener(event, this.up);
      this.cursor.removeEventListener('keydown', this.keydown);
      this.reduced.removeEventListener('change', this.preference);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsync-difference"] && !Shopify.designMode) return;
  try {
    
  if (!window.unsyncDifferenceClickBound) {
    window.unsyncDifferenceClickBound = true;
    document.addEventListener('click', function(event) {
      const link = event.target.closest('[data-unsync-product-scroll]');
      if (!link) return;
      const product = document.querySelector('[id^="MainProduct-"]');
      if (!product) return;
      event.preventDefault();
      product.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsync-floating-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('unsync-scroll-product')) {
  customElements.define('unsync-scroll-product', class extends HTMLElement {
    connectedCallback() {
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = 0;
      this.update = () => {
        this.frame = 0;
        const rect = this.getBoundingClientRect();
        const viewport = window.innerHeight;
        // Hold the starting tilt until the stage enters; face forward at 65% viewport.
        const distance = viewport * .35 + rect.height * .5;
        const progress = Math.max(0, Math.min(1, (viewport - rect.top) / distance));
        const eased = progress * progress * (3 - 2 * progress);
        const tilt = Number(this.dataset.tilt) || 12;
        const angle = this.reduced.matches || this.dataset.motion !== 'true' ? 0 : tilt * (1 - eased);
        this.style.setProperty('--product-angle', angle.toFixed(3) + 'deg');
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      this.update();
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule, { passive: true });
      this.reduced.addEventListener('change', this.schedule);
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(this);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.reduced.removeEventListener('change', this.schedule);
      this.resizeObserver.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["unsync-how-to-use"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('unsync-step-slider')) {
    customElements.define('unsync-step-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ust__track');
        this.previous = this.querySelector('.ust__arrow--previous');
        this.next = this.querySelector('.ust__arrow--next');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ust__card');
          if (!card) return;
          const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left - padding;
          this.track.scrollTo({ left, behavior: 'auto' });
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      move(direction) {
        const card = this.track.querySelector('.ust__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      update() {
        const overflow = this.track.scrollWidth - this.track.clientWidth;
        this.previous.hidden = this.next.hidden = overflow < 2;
        this.previous.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft >= overflow - 2;
        const media = this.track.querySelector('.ust__media');
        if (media) this.style.setProperty('--ust-arrow-top', `${media.getBoundingClientRect().height / 2}px`);
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
